import { render, staticRenderFns } from "./ContactStats.vue?vue&type=template&id=bb7e53aa&scoped=true&"
import script from "./ContactStats.vue?vue&type=script&lang=js&"
export * from "./ContactStats.vue?vue&type=script&lang=js&"
import style0 from "./ContactStats.vue?vue&type=style&index=0&id=bb7e53aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7e53aa",
  null
  
)

export default component.exports